export const navItems = [
  { name: "About", link: "#about" },
  { name: "Hackathon Tools", link: "#tools" },
  { name: "Apply", link: "#contact" },
];

export const gridItems = [
  {
    id: 1,
    title: "Low/No-Code Solutions that change the world",
    description: "",
    className: "lg:col-span-3 md:col-span-6 md:row-span-4 lg:min-h-[60vh]",
    imgClassName: "w-full h-full",
    titleClassName: "justify-end",
    img: "/b1.svg",
    spareImg: "",
  },
  {
    id: 2,
    title: "Shaping the Post-pandemic SocIoTy",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-2",
    imgClassName: "",
    titleClassName: "justify-start",
    img: "",
    spareImg: "",
  },
  {
    id: 3,
    title: "Capture-the-Flag Challenges",
    description: "Let the Best Win",
    className: "lg:col-span-2 md:col-span-3 md:row-span-2",
    imgClassName: "",
    titleClassName: "justify-center",
    img: "",
    spareImg: "",
  },
  {
    id: 4,
    title: "Smart Cities, Homes and Buildings",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-1",
    imgClassName: "",
    titleClassName: "justify-start",
    img: "/grid.svg",
    spareImg: "/b4.svg",
  },
  {
    id: 5,
    title: "Problem Solving in Smart Environments using Locsys platform",
    description: "#SocIIoTy",
    className: "md:col-span-3 md:row-span-2",
    imgClassName: "absolute right-0 bottom-0 md:w-96 w-60",
    titleClassName: "justify-center md:justify-start lg:justify-center",
    img: "/b5.svg",
    spareImg: "/grid.svg",
  },
  {
    id: 6,
    title: "Ready to Join the Hackathon?",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-1",
    imgClassName: "",
    titleClassName: "justify-center md:max-w-full max-w-96 text-center",
    img: "",
    spareImg: "",
  },
];

export const projects = [
  {
    id: 1,
    title: "Locsys Platform",
    des: "The Low-Code platform for Systems Engineering",
    img: "locsys.png",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/fm.svg"],
    link: "https://locsys.issel.ee.auth.gr",
    popTitle: "Locsys",
  },
  {
    id: 2,
    title: "EnvPop",
    des: "A No-Code tool to setup and configure smart Environments",
    img: "EnvPop.jpg",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/fm.svg"],
    link: "https://locsys.issel.ee.auth.gr",
    popTitle: "EnvPop",
  },
  {
    id: 3,
    title: "AppCreator",
    des: "A Graphical tool for creating applications in a flow/FSM-like manner",
    img: "AppCreator.jpg",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/fm.svg"],
    link: "https://locsys.issel.ee.auth.gr",
    popTitle: "AppCreator",
  },
];

export const wordSfhmmy =
  "SocIIoTy is a virtual competition where participants are invited to create solutions for everyday scenarios, in smart environments. The tasks will be programmed on the Locsys low-code platform. You will be given several tasks in different smart environments and through the Locsys platform you will create an application that solves each task. The environmental simulation and the application deployment will be visualized through the platform, and an automatic evaluation mechanism will exist, storing the scores in a leaderboard.";

export const testimonials = [
  {
    quote:
      "Collaborating with Adrian was an absolute pleasure. His professionalism, promptness, and dedication to delivering exceptional results were evident throughout our project. Adrian's enthusiasm for every facet of development truly stands out. If you're seeking to elevate your website and elevate your brand, Adrian is the ideal partner.",
    name: "Michael Johnson",
    title: "Director of AlphaStream Technologies",
  },
  {
    quote:
      "Collaborating with Adrian was an absolute pleasure. His professionalism, promptness, and dedication to delivering exceptional results were evident throughout our project. Adrian's enthusiasm for every facet of development truly stands out. If you're seeking to elevate your website and elevate your brand, Adrian is the ideal partner.",
    name: "Michael Johnson",
    title: "Director of AlphaStream Technologies",
  },
  {
    quote:
      "Collaborating with Adrian was an absolute pleasure. His professionalism, promptness, and dedication to delivering exceptional results were evident throughout our project. Adrian's enthusiasm for every facet of development truly stands out. If you're seeking to elevate your website and elevate your brand, Adrian is the ideal partner.",
    name: "Michael Johnson",
    title: "Director of AlphaStream Technologies",
  },
  {
    quote:
      "Collaborating with Adrian was an absolute pleasure. His professionalism, promptness, and dedication to delivering exceptional results were evident throughout our project. Adrian's enthusiasm for every facet of development truly stands out. If you're seeking to elevate your website and elevate your brand, Adrian is the ideal partner.",
    name: "Michael Johnson",
    title: "Director of AlphaStream Technologies",
  },
  {
    quote:
      "Collaborating with Adrian was an absolute pleasure. His professionalism, promptness, and dedication to delivering exceptional results were evident throughout our project. Adrian's enthusiasm for every facet of development truly stands out. If you're seeking to elevate your website and elevate your brand, Adrian is the ideal partner.",
    name: "Michael Johnson",
    title: "Director of AlphaStream Technologies",
  },
];

export const companies = [
  {
    id: 1,
    name: "cloudinary",
    img: "/cloud.svg",
    nameImg: "/cloudName.svg",
  },
  {
    id: 2,
    name: "appwrite",
    img: "/app.svg",
    nameImg: "/appName.svg",
  },
  {
    id: 3,
    name: "HOSTINGER",
    img: "/host.svg",
    nameImg: "/hostName.svg",
  },
  {
    id: 4,
    name: "stream",
    img: "/s.svg",
    nameImg: "/streamName.svg",
  },
  {
    id: 5,
    name: "docker.",
    img: "/dock.svg",
    nameImg: "/dockerName.svg",
  },
];

export const workExperience = [
  {
    id: 1,
    title: "Participation in the SocIIoTy competition:",
    desc: "Join your colleagues from all over Greece to compete for prices",
    className: "md:col-span-2",
    thumbnail: "/exp1.svg",
  },
  {
    id: 2,
    title: "Smart systems application creation:",
    desc: "Design, test and provide your solutions for complex tasks in simulated smart environments",
    className: "md:col-span-2",
    thumbnail: "/exp2.svg",
  },
  {
    id: 3,
    title: "Virtual Challenge Competitor",
    desc: "Competed by solving various challenges in virtual smart environments with the Locsys platform.",
    className: "md:col-span-2",
    thumbnail: "/exp3.svg",
  },
  {
    id: 4,
    title: "Final Round Contestant",
    desc: "Reached the finals of SocIIoTy by successfully solving complex tasks in simulated environments.",
    className: "md:col-span-2",
    thumbnail: "/exp4.svg",
  },
];

export const socialMedia = [
  {
    id: 1,
    img: "/insta.svg",
    link: "https://www.instagram.com/sfhmmy",
    name: "Instagram",
  },
  {
    id: 2,
    img: "/link.svg",
    link: "https://www.linkedin.com/company/ecescon",
    name: "LinkedIn",
  },
  {
    id: 3,
    img: "/fb.png",
    link: "https://www.facebook.com/sfhmmy",
    name: "Facebook",
  },
];
